var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavIcon6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#141414"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3695_407)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2001 21.4331C17.4141 19.425 19.0114 18.0002 20.8194 18.0002L29.1754 18C30.9713 18 32.5641 19.4065 32.7881 21.4016C33.0714 23.9303 33.0707 26.0376 32.7854 28.5911C32.562 30.5884 30.9687 32 29.17 32H20.8228C19.0134 32 17.4154 30.5724 17.2014 28.5628C16.9334 26.04 16.9328 23.9466 17.2001 21.4331ZM20.8194 19.1668C19.5334 19.1668 18.4428 20.1585 18.2674 21.5001H31.7241C31.552 20.1578 30.4614 19.1668 29.1754 19.1668H20.8194ZM18.2614 28.4286C18.0428 26.371 18.0081 24.6225 18.1588 22.6668H31.8379C31.9953 24.623 31.9579 26.3773 31.7266 28.4496C31.5733 29.8184 30.4714 30.8333 29.17 30.8333H20.8228C19.5141 30.8333 18.4074 29.8067 18.2614 28.4286ZM22.0668 28.7918C22.3615 28.7918 22.6001 28.5308 22.6001 28.2085C22.6001 27.8862 22.3615 27.6251 22.0668 27.6251H19.9335C19.6388 27.6251 19.4001 27.8862 19.4001 28.2085C19.4001 28.5308 19.6388 28.7918 19.9335 28.7918H22.0668Z",
    fill: "#F2F2F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3695_407"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(17 17)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIcon6);
export default __webpack_public_path__ + "static/media/nav_icon_6.9bacd6657da0573429b84f8af3fc2668.svg";
export { ForwardRef as ReactComponent };